import { useAuthContext } from '../contexts'
import { Logo } from './Logo'
import { SideNav } from './SideNav'

export function NavBar() {
  const location = window.location.pathname
  const { isAuthorized } = useAuthContext()

  const showLogo =
    (!isAuthorized && location === '/') ||
    location === '/login' ||
    location === '/create-account' ||
    location === '/forgot-password'

  const links: { [key: string]: string } = isAuthorized
    ? {
        Home: '/',
        'Manage Data': '/manage-data',
        'User Preferences': '/user-preferences',
        'User Settings': '/user-settings',
        'Test Messages': '/test-messages',
        'Raw Messages': '/raw-messages',
        'Config Messages': '/config-messages',
        'Contact Us': '/contact',
        Logout: '/logout',
      }
    : {}

  return (
    <div>
      {showLogo && <Logo />}
      <div className="z-50 flex flex-row justify-between w-full bg-white position-fixed">
        {isAuthorized ? <SideNav links={links} /> : null}
      </div>
    </div>
  )
}
